import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Container, Row, Col, Table } from "react-bootstrap";


function Main(props) {
    
    const [activeIndex, setActiveIndex] = useState(props.activeIndex);

    const handleToggle = (index) => {
       
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    const ProjectPositions = 

    [
        {
            AdvertisementDate: <> 11.02.2025 </>,
            NameofthePost: <>Project Associate I (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2549.pdf",
                Text: "Advertisement for Project Associate I position in the Department of Physics - Advt/IITT/CSRC/24-25/49",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/RvH6Fg8p8L4nyvEP7",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 26.02.2025</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
           
                 },
                 ]
        },
        {
            AdvertisementDate: <> 11.02.2025 </>,
            NameofthePost: <>Postdoctoral Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2548.pdf",
                Text: "Advertisement for Postdoctoral Fellow position in the Department of Physics - Advt/IITT/CSRC/24-25/48",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/RvH6Fg8p8L4nyvEP7",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 26.02.2025</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
           
                 },
                 ]
        },
        {
            AdvertisementDate: <> 11.02.2025 </>,
            NameofthePost: <>Scientific Officer / Technical Engineer (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2547.pdf",
                Text: "Advertisement for Scientific Officer / Technical Engineer position in the Department of Physics - Advt/IITT/CSRC/24-25/47",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/bk48XoB2oYHGdvqq5",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 26.02.2025</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
           
                 },
                 ]
        },
        {
            AdvertisementDate: <> 11.02.2025 </>,
            NameofthePost: <>Research Associate III (02 Positions)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2546.pdf",
                Text: "Advertisement for Research Associate III position in the Department of Physics - Advt/IITT/CSRC/24-25/46",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/bk48XoB2oYHGdvqq5",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 26.02.2025</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
           
                 },
                 ]
        },
        {
            AdvertisementDate: <> 11.02.2025 </>,
            NameofthePost: <>Junior Research Fellow (02 Positions)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2545.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Physics - Advt/IITT/CSRC/24-25/45",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/bk48XoB2oYHGdvqq5",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 26.02.2025</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
           
                 },
                 ]
        },
        {
            AdvertisementDate: <> 11.02.2025 </>,
            NameofthePost: <>Research Intern (02 Positions)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2544.pdf",
                Text: "Advertisement for Research Intern position in the Department of Physics - Advt/IITT/CSRC/24-25/44",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/bk48XoB2oYHGdvqq5",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 26.02.2025</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
           
                 },
                 ]
        },
        {
            AdvertisementDate: <> 30.01.2025 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2543.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Civil and Environmental Engineering - Advt/IITT/CSRC/24-25/43",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/as1JVjPeF96os3EVA",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 13.02.2025</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
           
                 },
                 ]
        },
        {
            AdvertisementDate: <> 28.01.2025 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2024-2522_REA.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Mechanical and Chemical Engineering - Advt/IITT/CSRC/2024-25/22",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/5JkKiR9W2oTZcY776",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 12.02.2025 (5:00 PM By email)</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
           
                 },
                 ]
        },
        {
            AdvertisementDate: <> 21.01.2025 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2542.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Mechanical Engineering - Advt/IITT/CSRC/24-25/42",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/uLso6GUrJqvCqrEQA",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 05.02.2025</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
           
                 },
                 ]
        },

        {
            AdvertisementDate: <> 08.01.2025 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24_2541.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Chemical & Mechanical Engineering - Advt/IITT/CSRC/24-25/41",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/HXkGof4UFHR7Hrxu7",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 23.01.2025</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
           
                 },
                 ]
        },
        {
            AdvertisementDate: <> 17.01.2025 </>,
            NameofthePost: <>Project Lab Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2540.pdf",
                Text: "Advertisement for Project Lab Assistant position in the Department of Mechanical Engineering - Advt/IITT/CSRC/24-25/40",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/mBTJDkR45j9BNs9i9",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 26.01.2025</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
           
                 },
                 ]
        },
        {
            AdvertisementDate: <> 10.12.2024 </>,
            NameofthePost: <>Research Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITT_CSRC_24-25_39.pdf",
                Text: "Advertisement for Research Assistant position in the Department of Humanities and Social Sciences - Advt/IITT/CSRC/24-25/39",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/adtHZCVJSFWr3Vde9",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 25.12.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 04.12.2024 </>,
            NameofthePost: <>Junior Research Fellow (02 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2538.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Computer Science and Engineering - Advt/ IITT/CSRC/2024-25/38",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/9FSnQxc9fjNoS4wT9",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 19.12.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 04.12.2024 </>,
            NameofthePost: <>Project Associate (02 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2537.pdf",
                Text: "Advertisement for Project Associate position in the Department of Computer Science and Engineering - Advt/ IITT/CSRC/2024-25/37",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/YELcG2vtPckGcexm8",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 19.12.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
       
        {
            AdvertisementDate: <> 25.11.2024 </>,
            NameofthePost: <>Research Assistant / Project Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2536.pdf",
                Text: "Advertisement for Research Assistant / Project Assistant position in the Department of  Chemical / Mechanical / Civil & Environmental Engineering - Advt/ IITT/CSRC/2024-25/36",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/HwbUiYZhbvRxzEDT8",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 10.12.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 26.11.2024 </>,
            NameofthePost: <>Senior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2535.pdf",
                Text: "Advertisement for Senior Research Fellow position in the Department of Civil & Environmental Engineering - Advt/ IITT/CSRC/2024-25/35",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/dCjctPGqNQCiU2Ki9",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 10.12.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 25.11.2024 </>,
            NameofthePost: <>Scientific Administrative Assistant / Field worker (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2534.pdf",
                Text: "Advertisement for Scientific Administrative Assistant / Field worker position in the Department of  Civil & Environmental Engineering and Humanities and Social Sciences - Advt/ IITT/CSRC/2024-25/34",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/dCjctPGqNQCiU2Ki9",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 10.12.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 25.11.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2533.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Civil & Environmental Engineering - Advt/IITT/CSRC/2024-25/33",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/dCjctPGqNQCiU2Ki9",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 10.12.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 25.11.2024 </>,
            NameofthePost: <>Junior Research Fellow (02 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2532.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Civil & Environmental Engineeringg - Advt/ IITT/CSRC/2024-25/32",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/HwbUiYZhbvRxzEDT8 ",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 10.12.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 14.10.2024 </>,
            NameofthePost: <>Field Investigator (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2531.pdf",
                Text: "Advertisement for Field Investigator position in the Department of Humanities and Social Sciences - Advt/ IITT/CSRC/2024-25/31",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 28.11.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 14.10.2024 </>,
            NameofthePost: <>Research Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2530.pdf",
                Text: "Advertisement for Research Assistant position in the Department of Humanities and Social Sciences - Advt/IITT/CSRC/2024-25/30",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 28.11.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 12.10.2024 </>,
            NameofthePost: <>Project Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2529.pdf",
                Text: "Advertisement for Project Assistant position in the Department of Chemical and Mechanical Engineering - Advt/IITT/CSRC/2024-25/29",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 27.11.2024</>,
            Status:[
                 {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITT_CSRC_2024_25_29_Selected_candidate_list.pdf",
                    Text: "Selected Candidate List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"                    
                    },
                    glowstatus: "yes"
                }
                // glowstatus: "yes"
          
            
           
        ]
        },
        {
            AdvertisementDate: <> 24.10.2024 </>,
            NameofthePost: <>Project Associate / Senior Project Associate  (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2528.pdf",
                Text: "Advertisement for Project Associate / Senior Project Associate position in the Department of Chemical Engineering - Advt/ IITT/CSRC/2024-25/28",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 08.11.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 24.10.2024 </>,
            NameofthePost: <>Project Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2527.pdf",
                Text: "Advertisement for Project Assistant position in the Department of Chemical Engineering - Advt/ IITT/CSRC/2024-25/27",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 08.11.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 21.10.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2526.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Machanical / Electrical / Computer Science and Engineering - Advt/ IITT/CSRC/2024 -25/26",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 03.11.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 17.10.2024 </>,
            NameofthePost: <>Project Officer (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2525.pdf",
                Text: "Advertisement for Project Officer position in the Center of Excellence (CoE) (SM & EVT) - Advt/IITT/CSRC/2024-25/25",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 07.11.2024</>,
            Status:[
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2524_Selected_candidate_list_25.pdf",
                    Text: "Selected Candidate List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"                    
                    },
                    glowstatus: "yes"
                     
                },
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2525_Shortlisted_list.pdf",
                    Text: "Provisionally Shortlisted Candidates List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"                    
                    }
                    // glowstatus: ""
                     
                }
            
            
        ]
        },
        {
            AdvertisementDate: <> 17.10.2024 </>,
            NameofthePost: <>Assistant Manager (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2524.pdf",
                Text: "Advertisement for Assistant Manager position in the Center of Excellence (CoE) (SM & EVT) - Advt/IITT/CSRC/2024-25/24",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 07.11.2024</>,
            Status:[
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2524_Selected candidate_list_24.pdf",
                    Text: "Selected Candidate List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"                    
                    },
                    glowstatus: "yes"
                   
                },
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2524_Shortlisted_list.pdf",
                    Text: "Provisionally Shortlisted Candidates List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"                    
                    }
                    // glowstatus: ""
                   
                }
            
           
        ]
        },
        {
            AdvertisementDate: <> 17.10.2024 </>,
            NameofthePost: <>Project Officer (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2523.pdf",
                Text: "Advertisement for Project Officer position in the Center of Excellence (CoE) (SM & EVT) - Advt/IITT/CSRC/2024-25/23",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 07.11.2024</>,
            Status:[
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2524_Selected_candidate_list_23.pdf",
                    Text: "Selected Candidate List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"                   
                    },
                    glowstatus: "yes"
                },
                 {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2523_Shortlisted_list.pdf",
                    Text: "Provisionally Shortlisted Candidates List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify" 
                }
                // glowstatus: "yes"
            }
            
           
        ]
        },
        {
            AdvertisementDate: <> 03.10.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2522.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Chemical and Mechanical Engineering - Advt./IITT/CSRC/2024-25/22",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 18.10.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 02.09.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-2421.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Mechanical Engineering - Advt./IITT/CSRC/2023-24/21",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 17.09.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 13.08.2024 </>,
            NameofthePost: <>Project Associate (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2520.pdf",
                Text: "Advertisement for Project Associate position in the Department of Computer Science Engineering - Advt/IITT/CSRC/2024-25/20",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 28.08.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 13.08.2024 </>,
            NameofthePost: <>Junior Research Fellow (02 Positions)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2519_Exnd.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Computer Science and Engineering - Advt/IITT/CSRC/2024-25/19",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : Extended 11.09.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 09.08.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2518.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Mechanical Engineering - Advt/IITT/CSRC/2024-25/18",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 24.08.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 09.08.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2517.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Chemical Engineering - Advt/IITT/CSRC/2024-25/17",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 24.08.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 06.08.2024 </>,
            NameofthePost: <>Project Manager (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2501_7_8_24.pdf",
                Text: "Advertisement for Project Manager position (Innovation, Incubation, IPR, Start up and Industrial relations) at Centre for Sponsored Research and Consultancy (CSRC) - Advt./IITT/CSRC/2024-25/01",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 30.08.2024</>,
            Status:[
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2501_Selected_candidate_list.pdf",
                    Text: "Selected Candidate List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"                    
                    },
                    glowstatus: "yes"
                     
                }
            
        ]
        },
        {
            AdvertisementDate: <> 30.07.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITT-CSRC_2023-24_16.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Computer Science and Engineering - Advt/IITT/CSRC/2023-24/16",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 08.08.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 16.07.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-2415.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Chemical, Civil and Mechanical Engineering - Advt/ IITT/CSRC/2023-24/15",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 25.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 15.07.2024 </>,
            NameofthePost: <>Project Assistant Level 1 (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2514.pdf",
                Text: "Advertisement for Project Assistant Level 1 position in the Department of Chemical Engineering - Advt/IITT/CSRC/2024-25/14",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 30.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 15.07.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-2413.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Eletrical Engineering - Advt/ IITT/CSRC/2023-24/13",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 30.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 12.07.2024 </>,
            NameofthePost: <>Project Engineer (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/CSRC_23-24_12.pdf",
                Text: "Advertisement for Project Engineer position in the Department of Electrical Engineering - Advt/ IITT/CSRC/2023-24/12",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 27.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 11.07.2024 </>,
            NameofthePost: <>Project Associate  (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITT_CSRC_2024-25_11.pdf",
                Text: "Advertisement for Project Associate position in the Department of Electrical Engineering - Advt/ IITT/CSRC/2024-25/11",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 25.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 30.04.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2510.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Physics - Advt/ IITT/CSRC/2024-25/10",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 13.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 26.06.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-2409_27_6_24.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Civil and Environmental Engineering - Advt/ IITT/CSRC/2023-24/09",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 11.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 20.06.2024 </>,
            NameofthePost: <>Project Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt/ IITT/CSRC/2023-24/08 ",
                Text: "Advertisement for Project Assistant position in the Department of Chemical Engineering - Advt/ IITT/CSRC/2024-25/08",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 02.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 11.06.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2023-2407.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Chemistry and Chemical Engineering - Advt/ IITT/CSRC/2023-24/07",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 11.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 31.05.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2506.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Chemical Engineering - Advt/ IITT/CSRC/2024-25/06",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 20.06.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 31.05.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2505.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Humanities and Social Sciences - Advt/ IITT/CSRC/2024-25/05",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 20.06.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 29.05.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2504.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Mechanical Engineering - Advt/ IITT/CSRC/2024-25/04",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 13.06.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 30.04.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2503.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Chemical Engineering - Advt/ IITT/CSRC/2024-25/03",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 15.05.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 12.04.2024 </>,
            NameofthePost: <>Project Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2502_Updated.pdf",
                Text: "Advertisement for Project Assistant position in the Department of Chemical Engineering - Advt/ IITT/CSRC/2024-25/02",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : Extended till 01.05.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 03.04.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2501.pdf",
                Text: "Advertisement for Junior Research Fellow (JRF) position in the Department of Chemical Engineering - Advt/IITT/CSRC/2024-25/01",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 18.04.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        }
          

        

    ]


   
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Project Positions" />
            <section className="project-detail">
                <div className="container">
                    <div className="c-heading">
                        <h1>Project Positions</h1>
                    </div>

                    <Row>
                        <div className="card-body">

                            
                                    <Table bordered responsive className="mt-3 table table-striped">
                                    <thead>
                                        <tr className='c-tablehead'>
                                        <th>
                                        Date
                                            </th>
                                            <th>
                                                Name of the Post
                                            </th>
                                            <th>Advertisement</th>
                                            <th>
                                                Application
                                            </th>
                                            <th>
                                                Last Date
                                            </th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                    
                                    <tbody>
                                        {ProjectPositions.map((item, index) => (
                                            <tr key={index}>
                                                 <td>{item.AdvertisementDate}</td>
                                                <td>{item.NameofthePost}</td>
                                                <td>
                                                    {typeof item.Advertisement === 'string' ? item.Advertisement : (
                                                        <a href={item.Advertisement.Link} style={{ color: (item.Advertisement.Style && item.Advertisement.Style.color) }} target="_blank" >
                                                            {item.Advertisement.Text}
                                                        </a>
                                                    )}
                                                </td>
                                                <td>
                                                    {item.Application.map((status, i) => (
                                                        <div key={i}>
                                                            <a className={`text-maroon ${status.glowstatus === "yes" ? 'glowing-text' : ''}`} href={status.Link} target="_blank" >{status.Text}</a>
                                                        </div>
                                                    ))}
                                                </td>
                                                <td>{item.LastDate}</td>
                                                <td>
                                                    {Array.isArray(item.Status) ? (
                                                        item.Status.map((status, idx) => (
                                                            <div key={idx}>
                                                                <a className={`text-maroon ${status.glowstatus === "yes" ? 'glowing-text' : ''}`} href={status.Link} style={{ color: (status.color || (status.Style && status.Style.color)) }} target="_blank" >
                                                                {status.Text}
                                                                </a>
                                                            </div>
                                                        ))
                                                    ) : (
                                                            <a className={`text-marron ${item.Status.glowstatus == "yes" ? 'glowing-text' : ''}`} href={item.Status.Link} style={{ color: (item.Status.Style && item.Status.Style.color) }} target="_blank" >
                                                            {item.Status.Text}
                                                        </a>
                                                    )
                                                    
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                            
                                    </Table>     
                        </div>
   
                    </Row>
                </div>
            </section>
        </>
    );
}

export default Main;
